module.exports = __webpack_public_path__ + "static/img/2023_9_8_9.1656db65.1656db6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_9.1656db65.png
// module id = HpcS
// module chunks = 0